'use client'

import { Chat } from '@/lib/types'
import { AnimatePresence, motion } from 'framer-motion'

import { removeChat, shareChat as shareChatAction, disableSharedChat as disableSharedChatAction } from '@/app/(db)/actions'

import { SidebarActions } from '@/components/generic/sidebar-actions'
import { SidebarItem } from '@/components/generic/sidebar-item'

interface SidebarItemsProps {
  chats?: Chat[]
}

export function SidebarItems({ chats }: SidebarItemsProps) {
  if (!chats?.length) return null;
  // Defensive: filter out null/undefined or missing id
  const validChats = chats.filter(chat => chat && chat.id);
  if (!validChats.length) return null;
  return (
    <AnimatePresence>
      {validChats.map((chat, index) => (
        <motion.div key={chat.id} exit={{ opacity: 0, height: 0 }}>
          <SidebarItem index={index} chat={chat}>
            <SidebarActions
              chat={chat}
              removeChat={removeChat}
              shareChat={shareChatAction as (id: string) => Promise<Chat | { error: string }>}
              disableSharedChat={disableSharedChatAction as (id: string) => Promise<Chat | { error: string }>}
            />
          </SidebarItem>
        </motion.div>
      ))}
    </AnimatePresence>
  );
}
